/**
 * Desktop/tablet side navigation - visible at 768px and above.
 */

import { useAppStore, type ViewId } from '../store/app';
import { useAuthStore } from '../store/auth';

const NAV_ITEMS: { id: ViewId; label: string }[] = [
  { id: 'today', label: 'Today' },
  { id: 'calendar', label: 'Calendar' },
  { id: 'tasks', label: 'Tasks' },
  { id: 'notes', label: 'Notes' },
  { id: 'settings', label: 'Settings' },
  { id: 'download', label: 'Download App' },
];

export function SideNav() {
  const activeView = useAppStore((s) => s.activeView);
  const setActiveView = useAppStore((s) => s.setActiveView);
  const logout = useAuthStore((s) => s.logout);
  const deferredInstallPrompt = useAppStore((s) => s.deferredInstallPrompt);
  const setInstallPrompt = useAppStore((s) => s.setInstallPrompt);

  const handleInstall = async () => {
    if (!deferredInstallPrompt) return;
    await deferredInstallPrompt.prompt();
    const { outcome } = await deferredInstallPrompt.userChoice;
    if (outcome === 'accepted') {
      setInstallPrompt(null);
    }
  };

  return (
    <aside
      className="desktop-only desktop-flex-col w-56 flex-shrink-0 h-full"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderRight: '1px solid var(--border-color)',
      }}
    >
      <div className="p-4 pb-2">
        <h1 className="text-lg font-bold" style={{ color: 'var(--accent)' }}>AnnaCalendar</h1>
      </div>

      <nav className="flex-1 p-3 space-y-1">
        {NAV_ITEMS.map((item) => {
          const isActive = activeView === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveView(item.id)}
              className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors"
              style={{
                backgroundColor: isActive ? 'var(--accent-soft)' : 'transparent',
                color: isActive ? 'var(--accent)' : 'var(--text-secondary)',
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
                  e.currentTarget.style.color = 'var(--text-primary)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = 'var(--text-secondary)';
                }
              }}
            >
              {item.label}
            </button>
          );
        })}
      </nav>

      <div className="p-3 space-y-2" style={{ borderTop: '1px solid var(--border-color)' }}>
        {deferredInstallPrompt && (
          <button
            onClick={handleInstall}
            className="w-full px-3 py-2 rounded-md text-sm font-medium transition-colors"
            style={{
              backgroundColor: 'var(--accent-soft)',
              color: 'var(--accent)',
            }}
          >
            Install App
          </button>
        )}
        <button
          onClick={logout}
          className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors"
          style={{ color: 'var(--text-muted)' }}
          onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--danger)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-muted)'; }}
        >
          Logout
        </button>
      </div>
    </aside>
  );
}
